import React from 'react';

const Header: React.FC = () => {
  return (
    <header style={{
      background: '#fff',
      borderBottom: '3px solid var(--primary)',
      padding: '0.75rem 2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    }}>
      <img
        src="/Ajar enterprise logo.png"
        alt="Ajar | Enterprise"
        style={{ height: '52px', objectFit: 'contain' }}
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
    </header>
  );
};

export default Header;
